import { render, staticRenderFns } from "./FlexibleCategoriesListing.vue?vue&type=template&id=2d3b5958"
import script from "./FlexibleCategoriesListing.vue?vue&type=script&lang=js"
export * from "./FlexibleCategoriesListing.vue?vue&type=script&lang=js"
import style0 from "./FlexibleCategoriesListing.vue?vue&type=style&index=0&id=2d3b5958&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports